export const Contracts = () => {
  function getContractsByChain(chainName) {
    let contracts = { collatsToken: undefined, nftVault: undefined };
    if (chainName === "eth") {
      contracts.collatsToken = process.env.NEXT_PUBLIC_COLLATS_ADDRESS_ETH;
      contracts.nftVault = process.env.NEXT_PUBLIC_NFT_VAULT_ADDRESS_ETH;
    } else if (chainName === "matic" || chainName === "polygon") {
      contracts.collatsToken = process.env.NEXT_PUBLIC_COLLATS_ADDRESS_POLYGON;
      contracts.nftVault = process.env.NEXT_PUBLIC_NFT_VAULT_ADDRESS_POLYGON;
    } else if (chainName === "bsc") {
      contracts.collatsToken = process.env.NEXT_PUBLIC_COLLATS_ADDRESS_BSC;
      contracts.nftVault = process.env.NEXT_PUBLIC_NFT_VAULT_ADDRESS_BSC;
    }
    return contracts;
  }

  function getContractsByChainId(chainId) {
    let contracts = { collatsToken: undefined, nftVault: undefined };
    if (chainId == `0x${Number(1).toString(16)}`) {
      contracts.collatsToken = process.env.NEXT_PUBLIC_COLLATS_ADDRESS_ETH;
      contracts.nftVault = process.env.NEXT_PUBLIC_NFT_VAULT_ADDRESS_ETH;
    } else if (chainId == `0x${Number(137).toString(16)}`) {
      contracts.collatsToken = process.env.NEXT_PUBLIC_COLLATS_ADDRESS_POLYGON;
      contracts.nftVault = process.env.NEXT_PUBLIC_NFT_VAULT_ADDRESS_POLYGON;
    } else if (chainId == `0x${Number(56).toString(16)}`) {
      contracts.collatsToken = process.env.NEXT_PUBLIC_COLLATS_ADDRESS_BSC;
      contracts.nftVault = process.env.NEXT_PUBLIC_NFT_VAULT_ADDRESS_BSC;
    }
    return contracts;
  }

  return { getContractsByChain, getContractsByChainId };
};
